import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { styled } from '@mui/styles';

export const DialogTitleWrapper = styled(DialogTitle)(({ theme }) => ({
  fontSize: theme.spacing(2.5),
  fontWeight: 600,
  textAlign: 'left',
  padding: theme.spacing(3, 4)
}));

export const DialogContentWrapper = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(3, 4)
}));

export const DialogActionsWrapper = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(3, 4)
}));
